import { Card } from "@/components/ui/card";
import { Truck, Clock, MapPin, Package, AlertCircle, CheckCircle } from "lucide-react";

const ShippingInfo = () => {
  const shippingZones = [
    { zone: "Lagos Island", days: "1-2", cost: "₦1,500" },
    { zone: "Lagos Mainland", days: "2-3", cost: "₦2,000" },
    { zone: "Abuja", days: "3-4", cost: "₦3,500" },
    { zone: "Port Harcourt", days: "3-5", cost: "₦4,000" },
    { zone: "Other Major Cities", days: "4-6", cost: "₦4,500" },
    { zone: "Remote Areas", days: "5-7", cost: "₦5,000+" }
  ];

  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="flex items-center gap-3 mb-8">
        <Truck className="h-8 w-8 text-primary" />
        <h1 className="text-3xl font-bold">Shipping Information</h1>
      </div>
      
      <div className="space-y-6">
        <Card className="p-6">
          <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
            <Clock className="h-5 w-5 text-primary" />
            Delivery Times & Rates
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b">
                  <th className="text-left py-2">Location</th>
                  <th className="text-left py-2">Delivery Time</th>
                  <th className="text-left py-2">Standard Rate</th>
                </tr>
              </thead>
              <tbody>
                {shippingZones.map((zone, index) => (
                  <tr key={index} className="border-b">
                    <td className="py-3">{zone.zone}</td>
                    <td className="py-3">{zone.days} business days</td>
                    <td className="py-3">{zone.cost}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>

        <Card className="p-6">
          <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
            <Package className="h-5 w-5 text-primary" />
            Shipping Methods
          </h2>
          <div className="space-y-4">
            <div>
              <h3 className="font-medium mb-2">Standard Delivery</h3>
              <p className="text-muted-foreground text-sm">
                Our standard delivery service covers all major cities in Nigeria. Orders are typically processed within 24 hours and delivered within the timeframes listed above.
              </p>
            </div>
            <div>
              <h3 className="font-medium mb-2">Express Delivery</h3>
              <p className="text-muted-foreground text-sm">
                Available for Lagos only. Same-day or next-day delivery for orders placed before 12 PM. Additional charges apply.
              </p>
            </div>
            <div>
              <h3 className="font-medium mb-2">Pickup Points</h3>
              <p className="text-muted-foreground text-sm">
                Select pickup locations available in Lagos, Abuja, and Port Harcourt. Save on delivery costs by collecting your order yourself.
              </p>
            </div>
          </div>
        </Card>

        <Card className="p-6">
          <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
            <MapPin className="h-5 w-5 text-primary" />
            Coverage Areas
          </h2>
          <p className="text-muted-foreground mb-4">
            We deliver to all 36 states in Nigeria. Remote areas may experience longer delivery times and higher shipping costs.
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <h3 className="font-medium mb-2 flex items-center gap-2">
                <CheckCircle className="h-4 w-4 text-green-500" />
                Major Coverage Areas
              </h3>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>• Lagos State</li>
                <li>• Abuja (FCT)</li>
                <li>• Rivers State</li>
                <li>• Oyo State</li>
                <li>• Kano State</li>
                <li>• Kaduna State</li>
              </ul>
            </div>
            <div>
              <h3 className="font-medium mb-2">Free Shipping</h3>
              <p className="text-sm text-muted-foreground">
                Free shipping available on orders above ₦50,000 for Lagos and ₦75,000 for other states.
              </p>
            </div>
          </div>
        </Card>

        <Card className="p-6 border-orange-200 bg-orange-50">
          <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-orange-600" />
            Important Information
          </h2>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• Delivery times exclude weekends and public holidays</li>
            <li>• Signature may be required for high-value items</li>
            <li>• Ensure your delivery address is complete and accurate</li>
            <li>• Track your order using the tracking number provided</li>
            <li>• Contact support for special delivery instructions</li>
          </ul>
        </Card>
      </div>
    </div>
  );
};

export default ShippingInfo;